'use client';
export * from './BaseIcon';
//# sourceMappingURL=index.js.map